import { defaultLogger, getLogger as loggerGetLogger } from './logger';
import { uuid } from './metaData';
export { default as longTaskObserver } from './longTaskObserver';
export {
  getMetadata,
  setDocId,
  setDocName,
  setVersion,
  extendMeta,
  uuid,
  setDomain
} from './metaData';
export { sendLog, sendAppAnalyze } from './sender';
export { isDebugMode } from './config';
import { setUserId as setLoggerUserId } from './autoLogger';
export { setProductName, setDebugMode, ignoreError } from './autoLogger';
export { setWikiId } from './appAnalyzeUtils';
import { UserInfo } from './types';
import { setUserInfo as setAppAnalyzeUserInfo } from './appAnalyzeUtils';

export {
  sendImmediately,
  collect,
  getLocalAppAnalyzeRecord,
  extendExtraAttr,
  radarCatchJsError
} from './appAnalyzeUtils';
export { getLocalLog } from './reporter';

export function setUserInfo(userInfo: UserInfo) {
  setLoggerUserId(userInfo.userId);
  setAppAnalyzeUserInfo(userInfo);
}

export function setUserId() {
  console.error('DocLogger:setUserId已经废弃');
}

export const getLogger = loggerGetLogger;

export default defaultLogger;
export const debug = defaultLogger.debug;
export const log = defaultLogger.log;
export const info = defaultLogger.info;
export const error = defaultLogger.error;
export const warn = defaultLogger.warn;

export const count = defaultLogger.count;
export const statistic = defaultLogger.statistic;
export const timeCost = defaultLogger.timeCost;
export const tag = defaultLogger.tag;
export const getTimeCostSince = defaultLogger.getTimeCostSince;
export const timeCostSince = defaultLogger.timeCostSince;

import { getFormatDate, consoleLog } from './utils';
import type { Weblog } from './loadWebLogger';

consoleLog(`Logger已加载:`, `当前时间:${getFormatDate()} uuid:${uuid}`);

declare global {
  interface Window {
    Raven?: any;
    EFWebLoggerConfig?: Object;
    EFWebLogger?: Weblog;
    DocLogger: any;
  }
}
